import { Injectable } from '@angular/core';
import {InterfaceService} from "@app/interfaces";
import {BehaviorSubject, Observable, Subject} from "rxjs/index";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LicenseContractService extends InterfaceService {

    private sidePanelDataSubject = new BehaviorSubject<any[]>([
        {
            stepText: this.translate.instant('licenses.m'),
            id: 'License',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: true,
            isStepDisable: false,
            sequence: 1,
          },
          {
            stepText: 'Add signature',
            id: 'Signature',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: false,
            isStepDisable: false,
            sequence: 2,
          },
          {
            stepText: 'Confirmation',
            id: 'Signature',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: false,
            isStepDisable: false,
            sequence: 3,
          },
          {
            stepText: 'Add-on details',
            id: 'License1',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: true,
            isStepDisable: false,
            sequence: 4,
          },
          {
            stepText: 'Add signature',
            id: 'Signature1',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: false,
            isStepDisable: false,
            sequence: 5,
          },
          {
            stepText: 'Confirmation',
            id: 'confirmation1',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: false,
            isStepDisable: false,
            sequence: 6,
          }
    ]);

    progressPanelData : any 

    private progressAccountType = new BehaviorSubject<any[]>([
        {
            stepText: 'Licence/Add-on',
            id: 'License',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: true,
            isStepDisable: false,
            sequence: 1,
          },
          {
            stepText: 'Confirmation',
            id: 'Signature',
            stepRouting: ['contract_license'],
            isStepRequired: true,
            stepPermission: true,
            isStepCompleted: false,
            stepActive: false,
            isStepDisable: false,
            sequence: 2,
          }
    ]);

    private closeModalSubject = new Subject<void>();
    closeModal$ = this.closeModalSubject.asObservable();

    private refreshLicensingDataSource = new Subject<{ from?: string }>();
    refreshLicensingData$ = this.refreshLicensingDataSource.asObservable();

    private closeResetSubject = new Subject<void>();
    closeReset$ = this.closeResetSubject.asObservable();

    private resetSubject = new Subject<void>();
    reset$ = this.resetSubject.asObservable();

    private stepSource = new BehaviorSubject<number>(1);
    step$ = this.stepSource.asObservable();

  constructor(private http: HttpClient,private translate :TranslateService) {
      super();
  }

    getLicenseStorage(params?: Object): Observable<any> {
        return this.http
            .get(this.getApiUrl('getStorageLicenseDetails', params));
    }

    getMasterContractNew(): Observable<any> {
      const queryParams = { isNewLicencing: 1 };
      return this.http.get(this.getApiUrl('getNewMasterContractDetails', queryParams));
    }

    getMasterContract(params?: any): Observable<any> {
        return this.http
            .get(this.getApiUrl('getMasterContractDetails', params));
    }

    getLicenseDetails(params?: Object): Observable<any> {
        return this.http
            .get(this.getApiUrl('getLicenseDetails', params));
    }

    getPurchaseOrder(isNewLicencing,id,params?: { limit?: number; page?: number }): Observable<any> {
      const queryParams = {
          isNewLicencing: isNewLicencing, //postPurchaseNewLicenses
          contractId: id ,   // contractId
          limit :params.limit,
          page : params.page
      };
      return this.http.get(this.getApiUrl('getPurchaseorderDetails', queryParams));
    }

    saveNewLicense(clientID: any, licenceTypeID: string, pricingPlanID: string, quantity: any, licenceID: any, commitmentID: number, emailid: string, pricingTemplateID: number, licenceName: string): Observable<any> {
      const isLicenceBased = true
      const isAddon = false
      
      const queryParams = {clientID,licenceTypeID,pricingPlanID,quantity,licenceID,commitmentID,emailid,pricingTemplateID,licenceName,isLicenceBased,isAddon};
        
        return this.http.post(this.getApiUrl('postPurchaseNewLicenses'), queryParams);
    }  

  // Licensed add-on purchase (license-based)
  purchaseLicensedAddOnPackage(payload: any): Observable<any> {
    return this.http.post(this.getApiUrl('addons/purchase'), payload);
  }

  // Non-licensed add-on purchase (credits/sms/etc.)
  purchaseNonLicensedAddOnPackage(payload: any): Observable<any> {
    return this.http.post(this.getApiUrl('addons/purchase'), payload);
  }

    saveLicense(data): Observable<any> {
        return this.http
            .post(this.getApiUrl('postPurchaseLicenses'), JSON.stringify(data));
    }

    getUserLicense(params?: Object): Observable<any> {
        return this.http
            .get(this.getApiUrl('get_adduservalidation', params));
    }

    getAllocatedLicense(params?: Object): Observable<any> {
      return this.http
            .get(this.getApiUrl('allocated_licence', params));
    }

    getLicensePriceDetails(clientID:any,licenceID: string, licenceTypeID: string, licenceTypesDetailsID: string,pricingPlanId:any,quantity:any): Observable<any> {
      const queryParams = { 
        'clientID' :clientID,
        'licenceID': licenceID,
        'licensetypeid': licenceTypeID,
        'licencetypedetailsid': licenceTypesDetailsID,
        'pricingPlanId':pricingPlanId,
        'nooflicences':quantity
      }
      return this.http
          .get(this.getApiUrl('product_licence/price', queryParams));
  }


  deleteNewLicenses(clientID: string, licenceTypeID: string, licensesQuantity: string, productID: string, licenceTypeCommitments: string, licenses: string): Observable<any> {
    const queryParams = { 
        'clientId': clientID,
        'licensetypeid': licenceTypeID,
        'licensesquntity': licensesQuantity,
        'productid': productID,
        'licencetypecommitments': licenceTypeCommitments,
        'licenceid': licenses
    };
    return this.http.delete(this.getApiUrl('postDeleteNewLicenses', queryParams));
    }

    deleteLicenses(data): Observable<any> {
        return this.http
            .post(this.getApiUrl('postDeleteLicenses'), JSON.stringify(data));
    }

    get sidePanelData$() {
        return this.sidePanelDataSubject.asObservable();
    }
    
    updateStepData(updatedData: any) {
        const currentData = this.sidePanelDataSubject.value;
        const updatedSidePanelData = currentData.map(step => 
          step.sequence === updatedData.sequence ? { ...step, ...updatedData } : step
        );
        this.sidePanelDataSubject.next(updatedSidePanelData);
    }
    getSidePanelContractDetails() {
      return this.sidePanelDataSubject.value;
    }

    get sidePanelDataAccountType$() {
      return this.progressAccountType.asObservable();
    }

    updateStepDataAccountType(updatedData: any) {
      const currentData = this.progressAccountType.value;
      const updatedSidePanelData = currentData.map(step =>
        step.sequence === updatedData.sequence ? { ...step, ...updatedData } : step
      );
      this.progressAccountType.next(updatedSidePanelData);
    }

    getSidePanelContractDetailsAccountType() {
      return this.progressAccountType.value;
    }

    closeModal() {
        this.closeModalSubject.next();
    }

  triggerRefreshLicensingData(from?: string) {
  this.refreshLicensingDataSource.next({ from });
}

  triggerCloseAndReset() {
    this.closeResetSubject.next();
  }

  triggerReset() {
    this.resetSubject.next();
  }

  purchaseOrderDataFetched$ = new Subject<boolean>();  // shared observable

  emitPurchaseOrderDataFetched(status: boolean) {
    this.purchaseOrderDataFetched$.next(status);
  }

  setStep(step: number) {
    this.stepSource.next(step);
  }

  getEversignDocumentStatus(documentId: string, params?: Object): Observable<any> {
    const url = this.getApiUrl(`eversign_document/${documentId}/status`, params);
    return this.http.get(url);
  }

  cancelClientLicenceDocument(clientsLicenceId: any): Observable<any> {
    const url = `cancel_client_licence_document/${clientsLicenceId}`;
    return this.http.put(this.getApiUrl(url), {});
  }

  downloadContract(contractId: any): Observable<Blob> {
    const url = `download_contract/${contractId}`;
    return this.http.get(this.getApiUrl(url), { responseType: 'blob' });
  }

  getUsers(isOwnerOrManager: number = 1): Observable<any> {
    return this.http.get(
      this.getApiUrl('get_users',{isOwnerOrManager: isOwnerOrManager}
      )
    );
  }

  contractContact(userId: number) {
    const url = 'clients/contract_contact';
    const payload = { userId: userId };
    return this.http.put(this.getApiUrl(url), payload);
  }

}
